/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getzoneServicesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CREATED_ZONEFARE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getexcludedzoneServicesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_EXCLUDED_ZONEFARE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  }, 
  getzoneServicefarebyid: (id) => {
    //console.log('url-->',API_ENDPOINTS.GET_ZONE_FARE_DETAILS_BY_ID + "/" + id);
    return axios.get(API_ENDPOINTS.GET_ZONE_FARE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addzoneservicefare: (data) => {
    return axios.post(API_ENDPOINTS.ADD_ZONE_FARE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updatezoneServicefare: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_ZONE_FARE_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  deletezoneServicefare: (id) => {
    //console.log('url-->',API_ENDPOINTS.DELETE_ZONE_FARE_BY_ID + "/" + id);
    return axios.delete(API_ENDPOINTS.DELETE_ZONE_FARE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
